let $body;

let React;
let UserStore;
let Waypoint;

$body = require("../helpers/helpers").default.body;

React = require("react");

UserStore = require("../stores/userstore").default;

import Sticky from "react-stickynode";

class UserNavigation extends React.Component {
  componentWillMount() {
    let me;
    me = this;
    $body.on("click", e => me.props.closeAllMenus($(e.target)));
    if (this.props.hasNotificationClass) {
      return this.hasNotificationClass = "has_notification";
    }
  }

  logOut(e) {
    e.preventDefault();
    return $("#logout-form").submit();
  }

  render() {
    let activity;
    let creatorAvatar;
    let i;
    let len;
    let notification;
    let ref;
    let userMenuClass;
    let openNotificationMenuClass;
    this.user = this.props.user;
    this._notifications = this.props.notifications;
    this.showUserMenu = this.props.showUserMenu;
    this.userMenuClass = this.props.userMenuClass;
    this.navMenuClass = this.props.navMenuClass;
    this.notificationMenuOpen = this.props.notificationMenuOpen;
    this.notificationsEmpty = this.props.notificationsEmpty;
    this.notificationLoading = this.props.notificationLoading;
    if (this.props.hasNotificationClass === false) {
      this.hasNotificationClass = "";
    }
    creatorAvatar = (
      <img
        src={this.user.avatar}
        title={gettext("User Profile")}
        className="profile"
      />
    );
    switch (true) {
      case this.user.is_anonymous:
        this.userNavigation = (
          <ul className="user-nav">
            <li>
              <a
                href="/accounts/login/"
                title={gettext("Login")}
                className="ui_key"
              >
                {gettext("Login")}
              </a>
            </li>
            <li>
              <a
                href="/accounts/pricing/"
                title={gettext("Create Account")}
                className="ui_sign-up"
              >
                {gettext("Create Account")}
              </a>
            </li>
          </ul>
        );
        break;
      default:
        this.notifications = [];
        if (this._notifications !== void 0) {
          ref = this._notifications;
          for (i = 0, len = ref.length; i < len; i++) {
            notification = ref[i];
            if (notification.get_action_display === "download") {
              activity = (
                <span className="activity">{gettext("downloaded")}</span>
              );
            } else if (notification.get_action_display === "purchase") {
              activity = (
                <span className="activity">{gettext("purchased")}</span>
              );
            } else if (notification.get_action_display === "favorite") {
              activity = (
                <span className="activity">{gettext("favorited")}</span>
              );
            } else if (notification.get_action_display === "kit") {
              activity = (
                <span className="activity">{gettext("collected")}</span>
              );
            }
            this.notifications.push(
              <li key={notification.id}>
                <a href={"/" + notification.sender} title={notification.sender}>
                  <img src={notification.avatar} title={notification.sender} />
                </a>
                {activity}
                <a
                  href={notification.permalink}
                  title={notification.term}
                  className="icon-term"
                >
                  {notification.term}
                </a>
              </li>,
            );
          }
          this.notifications.push(
            <li key={this.user.id} id="all-notifications">
              <a
                href={"/" + this.user.username + "/activity/"}
                title={gettext("See All Activity")}
              >
                {gettext("See All Activity")}
              </a>
            </li>,
          );
        } else if (this.notificationsEmpty === true) {
          this.notifications.push(
            <li key={0} id="no-notifications">
              <h3>{gettext("No Activity Yet")}</h3>
              <p>
                {gettext(
                  "Stay up to date when someone interacts with your icons",
                )}
              </p>
            </li>,
          );
        } else if (this.notificationLoading === true) {
          this.notifications.push(
            <li key={0} id="loading"><h4>loading your activity…</h4></li>,
          );
        }
        this.logout = (
          <li>
            <a
              id="logout-button"
              href="/accounts/logout/"
              className="ui_lock"
              title={gettext("Log Out")}
              onClick={this.logOut}
            >
              <span className="menu-link">{gettext("Log Out")}</span>
            </a>
          </li>
        );
        this.userDashBoard = (
          <li>
            <a
              href="/dashboard/"
              className="ui_dashboard"
              title={gettext("Dashboard")}
            >
              <span className="menu-link">{gettext("Dashboard")}</span>
            </a>
          </li>
        );
        this.userSettings = (
          <li>
            <a
              href={"/" + this.user.username + "/settings/basics/"}
              className="ui_cog"
              title={gettext("Settings")}
            >
              <span className="menu-link">{gettext("Settings")}</span>
            </a>
          </li>
        );
        if (this.user.has_member_account) {
          this.upgrade = (
            <li>
              <a
                href={"/" + this.user.username + "/settings/upgrade/"}
                className="ui_pro-accounts"
                title={gettext("Upgrade Account")}
              >
                <span className="menu-link">{gettext("Upgrade Account")}</span>
              </a>
            </li>
          );
        }
        if (this.user.has_team_account) {
          this.teamSettings = (
            <li>
              <a
                href="/settings/seats/"
                className="ui_team-accounts"
                title={gettext("Team Settings")}
              >
                <span className="menu-link">{gettext("Team Settings")}</span>
              </a>
            </li>
          );
        }
        if (this.user.is_superuser) {
          this.fort = (
            <li>
              <a href="/fort/" className="ui_starter" title={gettext("FORT!")}>
                <span className="menu-link">{gettext("Admin Fort")}</span>
              </a>
            </li>
          );
        }
        if (this.showUserMenu) {
          userMenuClass = "show-user-menu";
        } else {
          userMenuClass = "hide-user-menu";
        }
        if (this.notificationMenuOpen) {
          openNotificationMenuClass = "open";
        } else {
          openNotificationMenuClass = "closed";
        }
        this.userNavigation = (
          <ul className="user-nav">
            <li className="user-actions">
              <a
                href="#"
                onClick={this.props.toggleCreatorNav.bind(this)}
                className={"profile avatar " + this.userMenuClass}
              >
                {creatorAvatar}
              </a>
              <ul className={userMenuClass}>
                {this.userDashBoard}
                {this.userSettings}
                {this.upgrade}
                {this.teamSettings}
                {this.fort}
                {this.logout}
              </ul>
            </li>
            <li>
              <a
                href="#"
                title={gettext("Activity Feed")}
                className={
                  "ui_notifications " +
                    this.hasNotificationClass +
                    " " +
                    this.navMenuClass
                }
                onClick={this.props.getNotifications}
              />
              <ul className={"notifications-list " + openNotificationMenuClass}>
                {this.notifications}
              </ul>
            </li>
            <li>
              <a
                href={"/" + this.user.username + "/kits/"}
                className="ui_kit"
                title={gettext("Your Kits")}
              />
            </li>
            <li>
              <a
                href="/upload/"
                title={gettext("Upload")}
                className="ui_upload"
              />
            </li>
          </ul>
        );
    }
    return this.userNavigation;
  }
}

class StaticNavigation extends React.Component {
  render() {
    let staticNavigation;
    this.user = this.props.user;
    if (this.props.overflowMenuVisible) {
      this.activeClass = "active";
    } else {
      this.activeClass = "";
    }
    this.logo = (
      <li>
        <a href="/" title="Noun Project" className="homepage-logo">
          <h1 className="ui_logo" />
        </a>
      </li>
    );
    this.macAppLink = (
      <li>
        <a
          href="/for-mac/"
          title={gettext("Noun Project for Mac")}
          className="ui_desktop"
        >
          {gettext("for Mac")}
        </a>
      </li>
    );
    this.noujiLink = (
      <li>
        <a
          href="/nounji/"
          title={gettext("Nounji on the new app store for iMessage")}
          className="ui_phone blue"
        >
          {gettext("Nounji")}
        </a>
      </li>
    );
    this.overflowMenu = (
      <li className="overflow">
        <a
          href="#"
          title={gettext("View More")}
          className={"overflow ui_view-more " + this.activeClass}
          onClick={this.props.toggleOverFlowMenu}
        />
      </li>
    );
    switch (true) {
      case this.user.is_anonymous:
        this.pricingLink = (
          <li>
            <a
              href="/accounts/pricing/"
              title={gettext("Pricing")}
              className="ui_dollar-sign-circle-filled"
            >
              {gettext("Pricing")}
            </a>
          </li>
        );
        this.uploadLink = (
          <li>
            <a
              href="/creators/"
              title={gettext("Creators")}
              className="ui_upload"
            >
              {gettext("Creators")}
            </a>
          </li>
        );
        break;
      case this.user.has_member_account:
        this.pricingLink = (
          <li>
            <a
              href="/accounts/pricing/"
              title={gettext("Upgrade")}
              className="ui_dollar-sign-circle-filled"
            >
              {gettext("Upgrade")}
            </a>
          </li>
        );
        this.macAppLink = (
          <li>
            <a
              href="/for-mac/"
              title={gettext("Noun Project for Mac")}
              className="ui_desktop"
            >
              {gettext("for Mac")}
            </a>
          </li>
        );
        this.uploadLink = (
          <li>
            <a
              href="/creators/"
              title={gettext("Become A Creator")}
              className="ui_upload"
            >
              {gettext("Become A Creator")}
            </a>
          </li>
        );
        break;
      case this.user.has_pro_account:
      case this.user.has_team_account:
        this.pricingLink = undefined;
        this.macAppLink = (
          <li>
            <a
              href="/for-mac/"
              title={gettext("Noun Project for Mac")}
              className="ui_desktop"
            >
              {gettext("for Mac")}
            </a>
          </li>
        );
        this.uploadLink = (
          <li>
            <a
              href="/creators/"
              title={gettext("Become A Creator")}
              className="ui_upload"
            >
              {gettext("Become A Creator")}
            </a>
          </li>
        );
    }
    return staticNavigation = (
      <ul className="static-nav">
        {this.logo}
        {this.pricingLink}
        {this.macAppLink}
        {this.noujiLink}
        {this.uploadLink}
        {this.overflowMenu}
      </ul>
    );
  }
}

class Navigation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: UserStore.getAll().user,
      notifications: void 0,
      showUserMenu: false,
      userMenuClass: "",
      navigationStuckClass: "",
      notificationMenuOpen: false,
      overflowMenu: void 0,
      overflowMenuVisible: false,
    };
  }

  closeAllMenus($target) {
    if ($target.hasClass("overflow")) {
      if (this.state.overflowMenuVisible) {
        return this.setState({
          overflowMenu: void 0,
        });
      } else {
        return this.setState({
          notificationMenuOpen: false,
          showUserMenu: false,
          userMenuClass: "",
          navMenuClass: "",
        });
      }
    } else {
      if ($target.hasClass("profile") === false) {
        if ($target.hasClass("ui_notifications") === false) {
          if (this.state.overflowMenuVisible) {
            this.setState({
              overflowMenuVisible: false,
              overflowMenu: void 0,
              notificationMenuOpen: false,
              showUserMenu: false,
              userMenuClass: "",
              navMenuClass: "",
            });
          } else {
            this.setState({
              notificationMenuOpen: false,
              showUserMenu: false,
              userMenuClass: "",
              navMenuClass: "",
            });
          }
        }
      }
      if ($target.hasClass("profile")) {
        if (this.state.overflowMenuVisible) {
          this.setState({
            overflowMenuVisible: false,
            overflowMenu: void 0,
            notificationMenuOpen: false,
            navMenuClass: "",
          });
        } else {
          this.setState({
            notificationMenuOpen: false,
            navMenuClass: "",
          });
        }
      }
      if ($target.hasClass("ui_notifications")) {
        if (this.state.overflowMenuVisible === true) {
          return this.setState({
            overflowMenuVisible: false,
            overflowMenu: void 0,
            showUserMenu: false,
            userMenuClass: "",
          });
        } else {
          return this.setState({
            showUserMenu: false,
            userMenuClass: "",
          });
        }
      }
    }
  }

  componentWillMount() {
    UserStore.addListener("change", this.onAuthUser.bind(this));
    if ($(window).scrollTop() > 0) {
      return this.setState({
        navigationStuckClass: "stuck",
      });
    }
  }

  getNotifications(e) {
    e.stopPropagation();
    e.preventDefault();
    this.closeAllMenus($(e.target));
    if (this.state.notificationMenuOpen) {
      return this.setState({
        notifications: void 0,
        notificationMenuOpen: false,
        notificationLoading: false,
        navMenuClass: "",
      });
    } else {
      let user = this.state.user
      user.has_notification = false
      this.setState({
        notificationLoading: true,
        notificationMenuOpen: true,
        navMenuClass: "active",
        user: user,
      });
      return $.get("/notifications/")
        .done(
          (_this => (data, status, xhr) => {
            if (data.length === 0) {
              _this.setState({
                notificationsEmpty: true,
                notificationLoading: false,
              });
            } else {
              _this.setState({
                notifications: data,
                notificationLoading: false,
              });
            }
            return $.get("/clear-notications/")
              .done((data, status, xhr) => console.log("cleared notification"));
          })(this),
        )
        .fail((data, status, xhr) => console.log(data));
    }
  }

  onAuthUser() {
    if (UserStore.getAll().user.is_anonymous === false) {
      return this.setState({
        user: UserStore.getAll().user,
      });
    }
  }

  render() {
    return (
      <Sticky activeClass="header stuck" innerZ={100}>
        <section
          id="header"
          onMouseEnter={this.stuckSearchBarHack.bind(this, true)}
          onMouseLeave={this.stuckSearchBarHack.bind(this, false)}
        >
          <nav className="container row">
            <StaticNavigation
              user={this.state.user}
              toggleOverFlowMenu={this.toggleOverFlowMenu.bind(this)}
              overflowMenuVisible={this.state.overflowMenuVisible}
            />
            <UserNavigation
              user={this.state.user}
              hasNotificationClass={this.state.user.has_notification}
              closeAllMenus={this.closeAllMenus.bind(this)}
              notificationMenuOpen={this.state.notificationMenuOpen}
              showUserMenu={this.state.showUserMenu}
              userMenuClass={this.state.userMenuClass}
              navMenuClass={this.state.navMenuClass}
              toggleCreatorNav={this.toggleCreatorNav.bind(this)}
              getNotifications={this.getNotifications.bind(this)}
              notificationsEmpty={this.state.notificationsEmpty}
              notificationLoading={this.state.notificationLoading}
              notifications={this.state.notifications}
            />
          </nav>
          {this.state.overflowMenu}
        </section>
      </Sticky>
    );
  }

  stuckSearchBarHack(hover, e) {
    // this is a hack to move the searchbard component down on hover
    if ($("#header").parents(".sticky-outer-wrapper").hasClass("stuck")) {
      if (hover) {
        $("#search").css({ top: "25px" });
      } else {
        $("#search").css({ top: "0px" });
      }
    }
  }

  toggleCreatorNav(e) {
    e.stopPropagation();
    e.preventDefault();
    this.closeAllMenus($(e.target));
    if (this.state.showUserMenu) {
      this.userMenuClass = "";
      return this.setState({
        showUserMenu: false,
        userMenuClass: "",
      });
    } else {
      return this.setState({
        showUserMenu: true,
        userMenuClass: "active",
      });
    }
  }

  toggleOverFlowMenu(e) {
    e.preventDefault();
    this.closeAllMenus($(e.target));
    switch (this.state.overflowMenuVisible) {
      case true:
        return this.setState({
          overflowMenu: void 0,
          overflowMenuVisible: false,
        });
      case false:
        return this.setState({
          overflowMenu: (
            <div className="overflow-menu">
              <ul className="container row">
                <li>
                  <a href="/about/" title={gettext("About")} className="bolder">
                    <span className="menu-link"> {gettext("About")}</span>
                  </a>
                </li>
                <li>
                  <a href="/team/" title={gettext("Teams")} className="bolder">
                    <span className="menu-link"> {gettext("Teams")}</span>
                  </a>
                </li>
                <li>
                  <a
                    href="/developers/"
                    title={gettext("API")}
                    className="bolder"
                  >
                    <span className="menu-link"> {gettext("API")}</span>
                  </a>
                </li>
                <li>
                  <a
                    href="http://blog.thenounproject.com"
                    title={gettext("Blog")}
                  >
                    <span className="menu-link"> {gettext("Blog")}</span>
                  </a>
                </li>
                <li>
                  <a href="/jobs/" title={gettext("Jobs")}>
                    <span className="menu-link"> {gettext("Jobs")}</span>
                  </a>
                </li>
                <li>
                  <a href="/legal/" title={gettext("Legal")}>
                    <span className="menu-link"> {gettext("Legal")}</span>
                  </a>
                </li>
                <li>
                  <a
                    href="//thenounproject.zendesk.com/"
                    title={gettext("Help")}
                  >
                    <span className="menu-link"> {gettext("Help")}</span>
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="ui_close"
                    onClick={this.toggleOverFlowMenu.bind(this)}
                  />
                </li>
              </ul>
            </div>
          ),
          overflowMenuVisible: true,
        });
    }
  }
}

export default Navigation;
